"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_AUTH_APP_HEADER = exports.SHARED_AUTH_COOKIE_PREFIX = void 0;
exports.isSharedAuthCookieName = isSharedAuthCookieName;
exports.isSharedAuthSessionCookieName = isSharedAuthSessionCookieName;
/**
 * Better Auth's cookie prefix. Shipped iOS builds read the session cookie by
 * it, so it can't change.
 */
exports.SHARED_AUTH_COOKIE_PREFIX = "newform-auth";
/**
 * Whether a cookie name is one of Better Auth's, with or without the
 * `__Secure-` prefix it gets over HTTPS.
 */
function isSharedAuthCookieName(name) {
    return name
        .replace(/^__Secure-/, "")
        .startsWith(`${exports.SHARED_AUTH_COOKIE_PREFIX}.`);
}
/** Whether a cookie name is Better Auth's session token. */
function isSharedAuthSessionCookieName(name) {
    return (name.replace(/^__Secure-/, "") ===
        `${exports.SHARED_AUTH_COOKIE_PREFIX}.session_token`);
}
/**
 * Which app a Better Auth request comes from, for what it sends back: the
 * sign-in code email is NewForm One's unless the request names Framework.
 */
exports.SHARED_AUTH_APP_HEADER = "x-newform-app";
